/** Stable options: updating progress must not restart an in-flight PDF read. */
export const pdfOptions = {
  workerSrc: "/pdf.worker.mjs",
  assetsUrl: "/pdf-assets/",
  // Includes browser worker-script download and document parsing.
  loadTimeoutMs: 60000,
  maxBytes: 256 * 1024 * 1024,
};
